import { CardListResponse } from 'types/api/card-list';
import { ApiResponseCache } from 'types/data';

//START GENAI@CHATGPT4
export function getDcfCardBrand(
  cardData: ApiResponseCache['getSrcProfile'],
  targetId: string | undefined
): string | null {
  for (const brand in cardData) {
    const brandData: CardListResponse = cardData[brand] as CardListResponse;

    for (const profile of brandData.profiles) {
      for (const card of profile.maskedCards) {
        if (card.srcDigitalCardId === targetId) {
          return brand;
        }
      }
    }
  }

  return null;
}
//END GENAI@CHATGPT4
